// extracted by mini-css-extract-plugin
module.exports = {"icon-pw":"font_icon-pw__4aCXy","icon-mail":"font_icon-mail__1IA-r"};